import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Dropdown from '@/components/elements/Dropdown';
import { FaChevronDown } from 'react-icons/fa6';
import { isUrlActive } from '@/utils/isUrlActive';

interface NavigationDropdownProps {
  label: string;
  items: { label: string; path: string }[];
}

function NavigationDropdown({ items, label }: NavigationDropdownProps) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const isActive = items.some((item) => isUrlActive(item.path, location));
  const normalisedItems = items.map((item) => ({ label: item.label, to: item.path }));

  return (
    <Dropdown
      options={normalisedItems}
      dataCy='categories-dropdown'
      onToggleButtonClick={setIsOpen}
      toggleButtonVariant='navigation'
      toggleButtonContent={
        <span
          className={`flex pb-2 items-center gap-2 ${isActive ? 'text-shadow-bold desktopNav:gradient-border-bottom' : ''}`}
        >
          {label}
          <FaChevronDown
            size={16}
            className={`mb-[2px] transition-all duration-500 ${isOpen ? 'scale-y-[-1] mb-[0px]' : 'scale-y-[1]'}`}
          />
        </span>
      }
    />
  );
}

export default NavigationDropdown;
